resourcePaths = '{"rootPath":"","assetsPath":""}';function InputCurrency() {
  this.extends = [InputText];
  this.node = null;
  this.id = null;

  // Properties
  this.placeholder = "0.00";
  this.error = "";
  this.maxLength = null;
  this.maskOnBlur = true;
  this.optionalDecimals = false;
  this.noDecimals = false;
  this.noMinus = false;
  this.usePluginCurrencyMask = false; // New version of currency display

  // use jquery plugin mask for desktop/ios if the user is on IE or Android use a fallback on change
  this.mask = {
    format: null,
    placeholder: "",
    add: function (value) {
      return this._addMaskCallback(value);
    }.bind(this), // fallback mask
    remove: function (value) {
      return this._removeMaskCallback(value);
    }.bind(this), // fallback unmask
  };

  this.init = function () {
    // Classes
    this._classes = $.extend(this._classes, {
      currency: "input-currency",
      currency_icon: "input-currency__icon",
    });

    if (this.noDecimals) this.optionalDecimals = true;

    if (this.usePluginCurrencyMask) {
      this.maskOnBlur = false;

      this.mask.format = undefined;
      this.mask.alias = "mogoCurrency";
      if (this.noDecimals) {
        this.mask.digits = "0";
        this.mask.radixPoint = "";
      }
      if (this.noMinus) {
        this.mask.allowMinus = false;
      }
    }

    this._$currencyIcon = $("<div></div>");
    this._$currencyIcon.addClass(this._classes.currency_icon);

    // Setup
    this._super();
    this.containerDiv.addClass(this._classes.currency);
    this.containerDiv.prepend(this._$currencyIcon);
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this._super();
  };

  this._addMaskCallback = function (value) {
    // remove devimals from value
    if (this.noDecimals) value = String(value).split(".")[0];
    // remove minus sign from value
    if (this.noMinus) value = String(value).replace("-", "");

    // cleanup input before masking
    value = String(value).replace(/[^0-9.]/g, "");
    if (value === "") return value;
    return Formatters.formatMoney(String(value).replace(",", ""), {
      noCurrencySymbol: true,
      optionalDecimals: this.optionalDecimals,
    });
  };

  this._removeMaskCallback = function (value) {
    // remove decimals from value
    if (this.noDecimals) value = String(value).split(".")[0];
    // remove minus sign from value
    if (this.noMinus) value = String(value).replace("-", "");
    // remove all non-integers then remove any characters over inital maxLength
    var transformedVal = parseFloat(String(value).replace(/[^0-9.]/g, ""));
    return !isNaN(transformedVal) ? transformedVal : value;
  };
}
